import {Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";

import { fromEvent, merge, of } from 'rxjs';
import { delay, map, switchMap } from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";


/**
 * @ngModule RISCommonModule
 * Used instad of the native mouse enter event to trigger the specifed event handler only if a specific time had
 * passed after 'mouseenter' event before a 'mouseleave' event was fired.<br>
 * **note : If we want also want to do things on 'mouseleave' event we need to register to the native mouseleave event.**<br>
 * Input param:  delay the time to delay  the on mouse enter event handler.This is an **optional parameter that defaults to 400ms**.<br>
 * Output param: delayed-hover trigerd on a mouse enter to the element after a given time.<br>
 * @example -
 * <div class="wl-nav-main-wrapper" cpDelayedHover [class.collapsed]="isCollapsed && !isHover"
 * (delayed-hover)="handleHoverStart();"
 * (mouseleave)="handleHoverEnd($event);">
 *
 */


@UntilDestroy()
@Directive({
	// tslint:disable-next-line:directive-selector
	selector: '[cpDelayedHover]',
})
export class DelayedHoverDirective implements OnInit, OnDestroy {
	@Input()
	delay = 400;

	@Output('delayed-hover') hoverEvent = new EventEmitter();

	constructor(private readonly element: ElementRef) {}

	ngOnInit() {
		const hide$ = fromEvent(this.element.nativeElement, 'mouseleave').pipe(map(_ => false));
		const show$ = fromEvent(this.element.nativeElement, 'mouseenter').pipe(map(_ => true));

		merge(hide$, show$)
			.pipe(
				untilDestroyed(this),
				switchMap(show => {
					if (!show) {
						return of(false);
					}
					return of(true).pipe(delay(this.delay));
				})
			)
			.subscribe(show => {
				if (show) {
					this.hoverEvent.emit();
				}
			});
	}

	ngOnDestroy() {}
}
